import { apiClient } from '@/core/infra_api_client'

// ============= Types =============

export type DnsRecordType = 'A' | 'AAAA' | 'CNAME' | 'TXT' | 'MX' | 'SRV'

export interface DnsRecord {
  id: string
  environmentId: string
  name: string
  type: DnsRecordType
  value: string
  ttl: number
  createdAt: string
  updatedAt: string
}

export interface CreateDnsRecordRequest {
  environmentId: string
  name: string
  type: DnsRecordType
  value: string
  ttl?: number
}

export interface PaginatedResponse<T> {
  data: T[]
  total: number
  page: number
  perPage: number
  totalPages: number
}

// ============= API =============

const BASE_PATH = 'dns-records'

export async function listDnsRecords(params?: {
  page?: number
  perPage?: number
  environmentId?: string
  type?: string
}): Promise<PaginatedResponse<DnsRecord>> {
  const searchParams: Record<string, string | number | boolean> = {}
  if (params?.page) searchParams['page'] = params.page
  if (params?.perPage) searchParams['per_page'] = params.perPage
  if (params?.environmentId) searchParams['environment_id'] = params.environmentId
  if (params?.type) searchParams['type'] = params.type

  return apiClient.get<PaginatedResponse<DnsRecord>>(BASE_PATH, searchParams)
}

export async function createDnsRecord(data: CreateDnsRecordRequest): Promise<DnsRecord> {
  return apiClient.post<DnsRecord, CreateDnsRecordRequest>(BASE_PATH, data)
}

export async function deleteDnsRecord(id: string): Promise<void> {
  return apiClient.delete(`${BASE_PATH}/${id}`)
}
